import React from 'react';
import { Modal, Banner } from '@morressier/alembic';
import { Flex, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-light-svg-icons';
import { IFormFieldState } from '.';
import FormFieldSet from './FormFieldSet';

export type IPathValue = string | number | boolean | null;
export type IPathObject = { [key: string]: IPathValue | IPathObject };

interface IFormFieldSetModalProps {
  isOpen: boolean;
  fields: IFormFieldState[];
  label: string;
  submissionContextId: string;
  attentionBannerText?: string;
  onCancel: () => void;
  onSubmit: (updatedValues: Record<string, unknown>) => void;
  defaultValues?: IPathObject;
}

const FormFieldSetModal: React.FC<IFormFieldSetModalProps> = ({
  isOpen,
  fields,
  label,
  attentionBannerText,
  onCancel,
  onSubmit,
  defaultValues
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex flexDirection="column" gap={6} padding={6}>
        <Flex>
          <FontAwesomeIcon icon={faEdit} fontSize={32} />
        </Flex>

        <Text textStyle="headingGroup">Edit {label}</Text>

        {attentionBannerText && (
          <Flex marginTop={2}>
            <Banner
              content={<Text>{attentionBannerText}</Text>}
              heading="For your attention"
              variant="attention"
            />
          </Flex>
        )}

        <FormFieldSet
          fields={fields}
          onCancel={onCancel}
          onSubmit={onSubmit}
          defaultValues={defaultValues}
        />
      </Flex>
    </Modal>
  );
};

export default FormFieldSetModal;
